import React from "react";
import Head from "next/head";
import dynamic from "next/dynamic";
import mission from "../../public/Animation/mission.json";
import vision from "../../public/Animation/Vision.json";

const Player = dynamic(() => import("@lottiefiles/react-lottie-player").then(mod => mod.Player), { ssr: false });

export default function About() {
  return (
    <>
      {/* <Head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta name="keywords" content={metadata.keywords} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta charSet="utf-8" />
        <link rel="canonical" href={metadata.canonical} />
        <meta name="robots" content={metadata.robots} />
      </Head> */}

      <section className="mt-32">
        <div className="container mx-auto text-center px-4">
          <h1 className="text-3xl md:text-4xl font-semibold">
            About <span className="text-[#ff9245]">NeetSupport</span>
          </h1>
          <p className="text-sm md:text-base text-gray-500 mt-2">
            Your Medical Dream, Our Expert Guidance - Helping You Secure the Best Medical College with Clarity, Confidence, and Success.
          </p>
        </div>
      </section>

      <section className="!py-8 md:!py-24 !mx-4 md:!mx-20">
        <div className="container mx-auto flex flex-col lg:flex-row gap-2 md:gap-16 items-center px-4">
          {/* Images Section */}
          
          <div className="flex-1 grid grid-cols-2 gap-4 px-6">
            <div className="col-span-1 mt-8 md:mt-24">
              <img
                src="images/1.webp"
                alt="Support Image"
                className="rounded-md w-full h-auto"
              />
            </div>
            <div className="col-span-1 flex flex-col gap-4">
              <img
                src="images/2.webp"
                alt="Support Image"
                className="rounded-md w-full h-auto"
              />
              <img
                src="images/3.webp"
                alt="Guidance Image"
                className="rounded-md w-full h-auto"
              />
            </div>
          </div>

          <h2 className="text-2xl pt-8 sm:pt-0 sm:pb-6 text-xl md:text-3xl font-bold text-[#ff9245] block md:hidden">
              Welcome to NeetSupport.com
            </h2>
          

          {/* Text Section */}
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-bold text-[#ff9245] hidden md:block">
              Welcome to NeetSupport.com
            </h2>
            <p className="text-gray-700 mt-4 md:mt-6 leading-relaxed text-sm md:text-base">
              At NEET Support, we are committed to empowering future medical professionals as they navigate the intricate landscape of NEET counselling and admissions with assurance. We recognize that gaining entry into your ideal medical college demands more than simply excelling in the NEET exam—it necessitates strategic planning, comprehensive guidance, and steadfast support throughout the journey. That's our role; we provide our expertise to help make your experience as seamless and successful as possible.
              <br />
              <br />
              Our team of seasoned counsellors and support personnel diligently offers customized advice that caters to each student's individual profile, preferences, and objectives. We are here to take the uncertainty out of the NEET counselling process and assist you in obtaining the admission you have tirelessly worked for.
            </p>
          </div>
        </div>
      </section>

      <section className="md:!py-20 !mx-4 md:!mx-20">
        <div className="container mx-auto flex flex-col lg:flex-row gap-2 md:gap-16 items-center px-4">
          {/* Mission Text Section */}
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-bold text-[#ff9245]">Our Mission</h2>
            <p className="text-gray-700 mt-4 md:mt-6 leading-relaxed text-sm md:text-base">
              Our mission is both straightforward and impactful: to lead every NEET aspirant toward their desired medical college with assurance and clarity. We strive to be a trustworthy partner on your journey to medical success, ensuring that each student's dedication and effort culminates in an admission offer from their preferred institution.
              <br />
              <br />
              At NEET Support, we recognize the demanding nature of the medical admissions journey and the commitment it requires. Achieving admission to prestigious medical institutions goes beyond simply scoring well; it involves understanding the process, strategizing, and skillfully maneuvering through the counselling stages. Our objective is to offer this vital assistance, customizing our support to align with each student’s individual strengths, ambitions, and objectives. By reducing the anxiety and ambiguity of the process, we empower students to concentrate on their future preparations with assurance and tranquility.
            </p>
          </div>

          {/* Mission Lottie Animation */}
          <div className="flex-1 hidden md:block">
            <Player
              autoplay
              loop
              src={mission}
              style={{ width: "100%", height: "300px", md: { height: "300px" } }}
            />
          </div>
          <div className="flex-1 block md:hidden">
            <Player
              autoplay
              loop
              src={mission}
              style={{ width: "100%", height: "300px", md: { height: "400px" } }}
            />
          </div>
        </div>
      </section>

      <section className="!py-8 md:!py-20 !mx-4 md:!mx-20">
        <div className="container mx-auto flex flex-col lg:flex-row gap-2 md:gap-16 items-center px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#ff9245] block md:hidden">Our Vision</h2>
          {/* Vision Lottie Animation */}
          <div className="flex-1 hidden lg:block">
            <Player
              autoplay
              loop
              src={vision}
              style={{ width: "100%", height: "300px", md: { height: "400px" } }}
            />
          </div>

          {/* Vision Text Section */}
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-bold text-[#ff9245] hidden md:block">Our Vision</h2>
            <p className="text-gray-700 mt-4 md:mt-6 leading-relaxed text-sm md:text-base">
              At NEET Support, our goal is to innovate the future of NEET counselling by making it clear, efficient, and devoid of stress for every student. We aim to create a reliable platform that seamlessly combines advanced AI tools with expert insights to simplify the medical admission process. Our vision is to set a new benchmark by integrating leading-edge technology with personalized support, guiding students in their medical career paths. We envision a world where every NEET aspirant possesses the resources, confidence, and backing needed to make informed decisions and succeed in their medical aspirations.
            </p>
          </div>

          {/* Vision Lottie Animation (Mobile) */}
          <div className="flex-1 lg:hidden">
            <Player
              autoplay
              loop
              src={vision}
              style={{ width: "100%", height: "200px", md: { height: "300px" } }}
            />
          </div>
        </div>
      </section>
    </>
  );
}
